var exports = {
  "kL": "x61f99309--af73c8--container",
  "vR": "x61f99309--af73c8--tabs",
  "Io": "x61f99309--af73c8--tabs-redesigned",
};

module.exports = exports;
